var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoTransparentBackgroundCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108 128.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#93d500;}.c{fill:#87d1e6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.88,4.32H0L56.97,127.47c.18,.39,.57,.63,.99,.63h0c.43,0,.81-.25,.99-.63l19.45-42.03L40.88,4.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M88.37,63.56l16.52-35.53c.78-1.85,2.95-7.53,3.08-9.75,.28-4.91-1.13-9.11-4.24-12.6-3.11-3.48-7.05-5.37-11.82-5.64-4.91-.28-11.33,1.14-14.68,4.25-3.35,3.12-5.16,7.13-5.44,12.04-.05,.84-.05,1.66,0,2.56,.17,3.29,.87,6.52,1.96,9.63l14.62,35.04Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTransparentBackgroundCopy);
export default __webpack_public_path__ + "static/media/logoTransparentBackgroundCopy.f2baca0bbb2305da3b630ada2a582f54.svg";
export { ForwardRef as ReactComponent };